import type { FC, PropsWithChildren } from 'react';

const Layout: FC<PropsWithChildren> = ({ children }) => {
  return <main className="grow p-xl bg-level-01/full">{children}</main>;
};

Layout.displayName = 'Layout';

export { Layout };
